export class NoRolesOrModulesError extends Error {
  constructor(public isNoRolesOrModules = true) {
    super("User does not have any roles or modules assigned.");
    this.name = "NoRolesOrModulesError";
  }
}
